import { render, staticRenderFns } from "./ModifiersGroup.vue?vue&type=template&id=4cf7678e"
import script from "./ModifiersGroup.vue?vue&type=script&lang=js"
export * from "./ModifiersGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports